<template>
  <div class="container">
    <ml-table
      ref="loginLogTableRef"
      title="登录日志"
      :url="$API.login_log_post"
      :defaultConfig="listTableConfig"
      :mountQuery="true"
    >
      <el-table-column label="操作类型" slot="type" prop="type">
        <template slot-scope="scope">
          <span>{{ scope.row.type === 0 ? '登入' : '登出' }}</span>
        </template>
      </el-table-column>
    </ml-table>
  </div>
</template>

<script>
export default {
  name: 'loginLog',
  data() {
    return {
      listTableConfig: {
        columns: [
          {
            prop: 'realName',
            label: '操作人',
            filter: {
              label: '操作人',
              prop: 'realName',
            },
          },
          {
            prop: 'createdAt',
            label: '操作时间',
            filter: {
              label: '操作时间',
              prop: 'createdAt',
              component: 'DateRange',
              start: 'startTime',
              end: 'endTime',
            },
          },
          {
            slot: 'type',
            label: '操作类型',
            filter: {
              label: '操作类型',
              prop: 'type',
              component: 'DictSelect',
              type: 'LOGIN_LOG_TYPE',
            },
          },
          {
            prop: 'title',
            label: '操作内容',
            minWidth: '250',
          },
          {
            prop: 'clientIp',
            label: 'IP地址',
          },
        ],
      },
    };
  },
  methods: {},
};
</script>
